export const IsTextEncoderAvailable = () => {
    return typeof TextEncoder !== 'undefined';
};
//# sourceMappingURL=textEncoder.js.map